export const getModulePermissions = (authState) => {
  const modules = authState?.moduleAccess?.modules || {};
  return {
    ...modules,
    dashboard: {
      ...modules.dashboard,
      view: true,
    },
  };
};

export const canViewModule = (modulePermissions, moduleName) =>
  Boolean(modulePermissions?.[moduleName]?.view);

export const canEditModule = (modulePermissions, moduleName) =>
  Boolean(modulePermissions?.[moduleName]?.edit);

export const hasAnyModuleView = (modulePermissions, moduleNames = []) =>
  moduleNames.some((moduleName) => canViewModule(modulePermissions, moduleName));

export const isBookingAdmin = (authState) => {
  const userObj =
    authState?.userInfoData ||
    authState?.userInfo?.userInfo ||
    authState?.userInfo ||
    {};
  const roles = userObj?.roles || [];
  if (!Array.isArray(roles) || roles.length === 0) return false;

  return roles.some((role) => {
    const roleName = typeof role === "string"
      ? role.toLowerCase().trim()
      : (role?.name || role?.role_name || "").toLowerCase().trim();
    return (
      roleName === "super admin" ||
      roleName === "seat management module admin" ||
      roleName === "booking module admin"
    );
  });
};

export const isKpiAdmin = (authState) => {
  const userObj =
    authState?.userInfoData ||
    authState?.userInfo?.userInfo ||
    authState?.userInfo ||
    {};
  let roles = userObj?.roles || [];

  if ((!Array.isArray(roles) || roles.length === 0) && localStorage.getItem("logininfo")) {
    try {
      const parsed = JSON.parse(localStorage.getItem("logininfo"));
      const inner = parsed?.userInfo || parsed;
      if (Array.isArray(inner?.roles)) {
        roles = inner.roles;
      }
    } catch (e) {
      console.error(e);
    }
  }

  if (!Array.isArray(roles) || roles.length === 0) return false;

  return roles.some((role) => {
    const roleName = typeof role === "string"
      ? role.toLowerCase().trim()
      : (role?.name || role?.role_name || "").toLowerCase().trim();
    return (
      roleName === "super admin" ||
      roleName === "kpi module admin"
    );
  });
};

export const hasPeopleModuleAdminAccess = (profileData = null, authState = null) => {
  const TARGET_ID = "6a0dbd47fc3fd632f3d88d54";
  const TARGET_NAME = "people module admin";

  let parsedStorage = null;
  if (typeof window !== "undefined" && localStorage.getItem("logininfo")) {
    try {
      parsedStorage = JSON.parse(localStorage.getItem("logininfo"));
    } catch (e) {
      console.error(e);
    }
  }

  const sources = [
    profileData,
    profileData?.data,
    profileData?.user,
    profileData?.userInfo,
    authState?.userInfoData,
    authState?.userInfo?.userInfo,
    authState?.userInfo,
    parsedStorage?.userInfo,
    parsedStorage?.userInfoData,
    parsedStorage,
  ];

  for (const src of sources) {
    if (!src) continue;

    const candidateLists = [
      src.permissions,
      src.roles,
      src.additional_roles,
      src.additional_permissions,
      src.user_permissions,
      src.user_roles,
    ];

    for (const list of candidateLists) {
      if (Array.isArray(list)) {
        const found = list.some((item) => {
          if (!item) return false;
          if (typeof item === "string") {
            const str = item.trim().toLowerCase();
            return str === TARGET_ID || str === TARGET_NAME;
          }
          const id = String(item._id || item.id || "").trim();
          const name = String(item.name || item.title || item.role_name || "").trim().toLowerCase();
          return id === TARGET_ID || name === TARGET_NAME;
        });
        if (found) return true;
      }
    }
  }

  return false;
};

